// extracted by mini-css-extract-plugin
export default {"content":"style_content__tkIX9","itemName":"style_itemName__xRSLT","mediaPreview":"style_mediaPreview__h7Qfh","videoPlayer":"style_videoPlayer__6W-xa"};